function buildRatingOverlays() {
  document.querySelectorAll('.card-wrapper').forEach(function(card) {
    if (card.querySelector('.za-rating-overlay')) return;
    var badge = card.querySelector('.jdgm-prev-badge');
    if (!badge) return;
    var avg = parseFloat(badge.getAttribute('data-average-rating') || 0);
    var count = parseInt(badge.getAttribute('data-number-of-reviews') || 0);
    if (!avg || avg === 0 || !count || count === 0) return;
    var inner = card.querySelector('.card__inner');
    if (!inner) return;
    var el = document.createElement('div');
    el.className = 'za-rating-overlay';
    el.innerHTML = '<span class="za-star">&#9733;</span> ' + avg.toFixed(1) + ' <span class="za-sep">|</span> ' + count;
    inner.appendChild(el);
  });
}

document.addEventListener('DOMContentLoaded', buildRatingOverlays);
setTimeout(buildRatingOverlays, 1000);
setTimeout(buildRatingOverlays, 2500);
setTimeout(buildRatingOverlays, 5000);
document.addEventListener('jdgm.loadBadges.complete', buildRatingOverlays);